import React from 'react';

const Footer = () => {
  return (
    <footer className="bg-gradient-to-b from-gray-900 to-black text-white">
      <div className="container mx-auto px-4 py-16">
        {/* Main Footer Content */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-12">
          {/* Brand Section */}
          <div className="space-y-4">
            <h3 className="text-2xl font-bold bg-gradient-to-r from-yellow-400 to-yellow-600 bg-clip-text text-transparent">
              Hope From The Pope
            </h3>
            <p className="text-gray-400">
              The most blessed meme coin in crypto. The hope of the christain faith.
            </p>
          </div>

          {/* Quick Links */}
          <div className="space-y-4">
            <h3 className="text-xl font-semibold text-yellow-400">Quick Links</h3>
            <div className="flex flex-col space-y-2">
              <a 
                href="#home" 
                className="text-gray-400 hover:text-yellow-400 transition-colors duration-300"
              >
                Home
              </a>
              <a 
                href="#tokenomics" 
                className="text-gray-400 hover:text-yellow-400 transition-colors duration-300"
              >
                Tokenomics
              </a>
              <a 
                href="#how-to-buy" 
                className="text-gray-400 hover:text-yellow-400 transition-colors duration-300"
              >
                How to Buy
              </a>
              <a 
                href="#roadmap" 
                className="text-gray-400 hover:text-yellow-400 transition-colors duration-300"
              >
                Roadmap
              </a>
            </div>
          </div>

          {/* Social Media */}
          <div className="space-y-4">
            <h3 className="text-xl font-semibold text-yellow-400">Social Media</h3>
            <div className="flex flex-col space-y-2">
              <a 
                href="https://twitter.com" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-yellow-400 transition-colors duration-300 flex items-center gap-2"
              >
                <span className="text-xl">🐦</span> Twitter
              </a>
              <a 
                href="https://telegram.org" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-yellow-400 transition-colors duration-300 flex items-center gap-2"
              >
                <span className="text-xl">📱</span> Telegram
              </a>
              <a 
                href="https://discord.com" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-yellow-400 transition-colors duration-300 flex items-center gap-2"
              >
                <span className="text-xl">💬</span> Discord
              </a>
            </div>
          </div>
        </div>

        {/* Divider */}
        <div className="h-px bg-gradient-to-r from-transparent via-yellow-400/20 to-transparent my-8"></div>

        {/* Copyright */}
        <div className="text-center text-gray-400 text-sm">
          <p>&copy; {new Date().getFullYear()} Hope From The Pope. All rights reserved.</p>
          <p className="mt-2 text-xs text-gray-500">
            Built with faith and blockchain technology 🙏
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 